import { render } from "./CustomCategory.vue?vue&type=template&id=2259f3c0&scoped=true&ts=true"
import script from "./CustomCategory.vue?vue&type=script&lang=ts"
export * from "./CustomCategory.vue?vue&type=script&lang=ts"

import "./CustomCategory.vue?vue&type=style&index=0&id=2259f3c0&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2259f3c0"]])

export default __exports__